import { Provider } from './Provider.model';
import { CustomerTag } from './Tag.model';

export enum CustomerTab {
  PROFILE = 'PROFILE',
  PRODUCTS = 'PRODUCTS',
  BOOKINGS = 'BOOKINGS',
}

export interface Customer {
  id: number;
  uuid: string;
  displayname: string;
  firstname: string;
  lastname: string;
  imageUrl: string;
  email: string;
  birthdate?: string;
  customerType?: string;
  lastVisit?: string;
  lastVisitUTC?: string;
  currentProduct?: string;
  color: string;
  amountDue?: number;
  currencySymbol?: string;
  paymentStatus?: string;
  tags?: CustomerTag[];
  pageNumber?: number; // NOT_USED just internally to make pagination faster.
  selected?: boolean; // for selction in list
}

export type ICustomerSimple = Partial<Customer> & {
  imageId?: string;
};

export interface ICreateCustomer extends Partial<FullCustomer> {
  domain: string;
  firstname: string;
  lastname: string;
  email?: string;
  phone?: string;
  imageId?: string;
}

export interface FullCustomer {
  id: number;
  uuid: string;
  number: string;
  salutation: string;
  gender: string;
  firstname: string;
  lastname: string;
  company: string;
  email: string;
  phone: string;
  language: string;
  languageCode: string;
  street: string;
  zipCode: string;
  city: string;
  birthdate: string;
  birthdateUTC: string;
  notes: string;
  customerTags: CustomerTag[];
  customerProviders: Provider[];
  phone2: string;
  email2: string;
  barcode: string;
  legalGuardian: string;
  parentphone: string;
  imageUrl: string;
  imageId: string;
  userId: string;
  userUUID: string;
  userUserName: string;
  userRegistrationDate: string;
  userRegistrationDateUTC: string;
  createdDate: string;
  createdDateUTC: string;
  invitationSent: string;
  invitationSentUTC: string;
  bankAccountHolder: string;
  bic: string;
  iban: string;
  color: string;
  sepaMandateId: string;
  sepaMandateDateOfSign: string;
  healthInsurance: string;
  fiscalCode: string;
  address?: string;
}

export enum CustomerBookingType {
  ACTIVE,
  CANCELLED,
  PAST,
}
